import { useState, useEffect } from 'react';
import throttle from 'raf-throttle';
import { isSSR } from './ssr';
export function useViewport(breakpoints = [768]) {
    const [mobile, desktop] = breakpoints;
    const [width, setWidth] = useState(isSSR ? 0 : window.innerWidth);
    useEffect(() => {
        const updateWidth = throttle(() => {
            setWidth(window.innerWidth);
        });
        window.addEventListener('resize', updateWidth);
        return () => {
            window.removeEventListener('resize', updateWidth);
        };
    }, []);
    if (typeof desktop === 'number') {
        return {
            width,
            isMobile: width < mobile,
            isTablet: width >= mobile && width < desktop,
            isDesktop: width >= desktop
        };
    }
    return {
        width,
        isMobile: width < mobile,
        isDesktop: width >= mobile
    };
}
